import { render, staticRenderFns } from "./customise.vue?vue&type=template&id=3ea96ee3&scoped=true"
import script from "./customise.vue?vue&type=script&lang=js"
export * from "./customise.vue?vue&type=script&lang=js"
import style0 from "./customise.vue?vue&type=style&index=0&id=3ea96ee3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea96ee3",
  null
  
)

export default component.exports